'use client'

import { FetchError } from '@ethena/shared-ui/src/types'
import { YieldResponse } from '@ethena/shared-ui/src/utils/edge/protocol-and-staking-yield'

import useSWR from 'swr'

import { UserCountResponse } from '@/app/api/user-count/route'
import { Stat } from '@/components/Stat'
import { IS_GERMAN } from '@/constants'
import { useTvl } from '@/hooks/useTvl'

export const HeadlineStatsSection = () => {
  const { usdeTvl, usdtbTvl } = useTvl()
  const { data: userCount } = useSWR<UserCountResponse, FetchError>('/api/user-count')
  const { data: yieldPoolData } = useSWR<YieldResponse, FetchError>('/api/yields/protocol-and-staking-yield')

  const susdeApy = yieldPoolData?.stakingYield?.value ? `${yieldPoolData?.stakingYield?.value.toFixed(0)}%` : undefined

  const stats = [
    {
      image: '/apy.svg',
      title: 'sUSDe APY',
      value: susdeApy,
    },
    {
      image: '/scales.svg',
      title: '2024 Avg sUSDe APY',
      value: '19%',
    },
    {
      image: '/usde-headline.svg',
      title: 'USDe Supply',
      value: usdeTvl,
    },
    {
      image: '/usdtb.svg',
      title: 'USDtb Supply',
      value: usdtbTvl,
    },
    {
      image: '/users.svg',
      title: 'Users',
      value: userCount?.count,
    },
    {
      image: '/chains.svg',
      title: 'Chains',
      value: '24',
    },
  ]

  if (IS_GERMAN) return null

  return (
    <div className="w-full">
      <div className="grid items-center justify-center gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
        {stats.map(stat => (
          <Stat key={stat.title} {...stat} />
        ))}
      </div>
    </div>
  )
}
